var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWatchlistMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "-565.3 244.5 58.7 61.7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-562.9 259.2v44.5h44v-44.5h-44zm6.2-2.4l2.5-10c.4-1.6 2-2.6 3.6-2.2L-509 255c1.6.4 2.6 2 2.2 3.6l-9.7 39v6.1c0 1.4-1.1 2.5-2.4 2.5h-44c-1.3 0-2.4-1.1-2.4-2.5v-44.5c0-1.4 1.1-2.5 2.4-2.5h6.2zm-.1 35.1c-.7 0-1.2.6-1.2 1.2s.6 1.2 1.2 1.2h31.8c.7 0 1.2-.6 1.2-1.2s-.6-1.2-1.2-1.2h-31.8zm0-11.7c-.7 0-1.2.6-1.2 1.2s.6 1.2 1.2 1.2h31.8c.7 0 1.2-.6 1.2-1.2s-.6-1.2-1.2-1.2h-31.8zm0-11.6c-.7 0-1.2.6-1.2 1.2s.6 1.2 1.2 1.2h31.8c.7 0 1.2-.6 1.2-1.2s-.6-1.2-1.2-1.2h-31.8z",
    fill: "#304256"
  })));
}

export default SvgWatchlistMenu;